import Requirements from './requirements';

export default Requirements;
